<template>
	<div class="v-progress-gauge">
		<v-progress-circular
			class="v-progress-mask"
			:rotate="135"
			:size="size"
			:width="width"
			:value="processedValue"
			color="blue"
		>
			<slot :value="value"></slot>
		</v-progress-circular>
		<v-progress-circular
			class="v-progress-overlay"
			:rotate="45"
			:size="size"
			:width="width"
			:value="25"
			color="white"
		>
		</v-progress-circular>
	</div>
</template>

<script>
  export default {
    name: 'v-progress-gauge',
    props: {
      size: {
        type: Number,
        default: 100
      },
      width: {
        type: Number,
        default: 15
      },
      value: {
        type: Number,
        default: 0
      },
    },
	computed: {
      processedValue(){
        return this.value * .75;
	  }
	}
  };
</script>

<style lang="stylus" scoped>
	.v-progress-gauge
		position: relative
		display: flex

	.v-progress-overlay
		position: absolute
		top: 0
		left: 0
</style>
